'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CcdViewerApp = require('./CcdViewerApp');

var _CcdViewerApp2 = _interopRequireDefault(_CcdViewerApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CcdViewerAppContainer = function (_Component) {
  _inherits(CcdViewerAppContainer, _Component);

  function CcdViewerAppContainer(props) {
    _classCallCheck(this, CcdViewerAppContainer);

    var _this = _possibleConstructorReturn(this, (CcdViewerAppContainer.__proto__ || Object.getPrototypeOf(CcdViewerAppContainer)).call(this, props));

    var careRecord = {};
    if (_this.props.careRecordJson) //make sure the string is not null empty
      {
        careRecord = JSON.parse(_this.props.careRecordJson); //convert careRecordJson to careRecord Object. //no longer has surrounding CareRecordContainer object;
      }
    _this.state = { careRecord: careRecord };
    return _this;
  }

  _createClass(CcdViewerAppContainer, [{
    key: 'isEmpty',
    value: function isEmpty(obj) {
      if (Array.isArray(obj) || typeof obj === 'string') {
        return obj.length === 0;
      }
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }
      return JSON.stringify(obj) === JSON.stringify({});
    }
  }, {
    key: 'hasData',
    value: function hasData(obj) {
      return !this.isEmpty(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      var demographics = null;
      var documentInformation = null;
      var sections = null;
      var customSections = {};
      var initialUserPreferences = null;
      var saveUserPreferencesCB = null;
      var isDownloadVersion = false;

      if (this.state.careRecord) {
        var careRecord = this.state.careRecord;
        if (careRecord.demographics) demographics = careRecord.demographics;
        if (careRecord.documentInformation) documentInformation = careRecord.documentInformation;
        if (careRecord.sections) sections = careRecord.sections;
        if (careRecord.viewPreferences && careRecord.viewPreferences.sectionPreferences) initialUserPreferences = careRecord.viewPreferences.sectionPreferences;

        //----customSections
        //careTeam
        if (careRecord.careTeam && this.hasData(careRecord.careTeam)) customSections.careTeam = careRecord.careTeam;
        if (careRecord.contributors && this.hasData(careRecord.contributors)) customSections.contributors = careRecord.contributors;
        if (careRecord.inFulfillmentOfs && this.hasData(careRecord.inFulfillmentOfs)) customSections.inFulfillmentOfs = careRecord.inFulfillmentOfs;
        if (careRecord.componentOf && this.hasData(careRecord.componentOf)) customSections.componentOf = careRecord.componentOf;
        if (careRecord.participants && this.hasData(careRecord.participants)) customSections.participants = careRecord.participants;
        if (careRecord.authorizations && this.hasData(careRecord.authorizations)) customSections.authorizations = careRecord.authorizations;
        if (careRecord.documentationOfs && this.hasData(careRecord.documentationOfs)) customSections.documentationOfs = careRecord.documentationOfs;
        if (careRecord.nonXmlBody && this.hasData(careRecord.nonXmlBody)) customSections.nonXmlBody = careRecord.nonXmlBody;

        if (this.props.saveUserPreferencesCB) saveUserPreferencesCB = this.props.saveUserPreferencesCB;

        if (this.props.isDownloadVersion) {
          isDownloadVersion = this.props.isDownloadVersion;
          initialUserPreferences = null; //We want default preferences for download TODO should probably just not set this in backend.
        }
      }

      return _react2.default.createElement(_CcdViewerApp2.default, {
        demographics: demographics,
        documentInformation: documentInformation,
        sections: sections,
        customSections: customSections,
        initialUserPreferences: initialUserPreferences,
        saveUserPreferencesCB: saveUserPreferencesCB,
        isDownloadVersion: isDownloadVersion
      });
    }
  }]);

  return CcdViewerAppContainer;
}(_react.Component);

CcdViewerAppContainer.PropTypes = {
  careRecordJson: _propTypes2.default.string, //json representation of a careRecord object
  saveUserPreferencesCB: _propTypes2.default.func, //Function to call to save user preferences
  isDownloadVersion: _propTypes2.default.bool
};

exports.default = CcdViewerAppContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/CcdViewerAppContainer.js
// module id = 1203
// module chunks = 0